export const getErrorCode = (errors) => {
  const error = [errors?.error || errors].flat()[0];
  return (
    error?.errorCode || error?.extensions?.errorCode || error?.extensions?.code
  );
};
